import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../../apollo-client';
import {appHistory} from '../../../../history';
import {store} from '../../../../store';

import {ImportFromCRMList} from './import-from-crm-list';

export function mountImportFromCRMList() {
    const importFromCRMListContainer = document.querySelector('#another-crm-react-mount');
    if (importFromCRMListContainer) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <ImportFromCRMList />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            importFromCRMListContainer
        );
    }
}
